import { BaseFiltroPagDTO } from "./base-dto";

export class PendenciaPrescricaoFiltroDTO extends BaseFiltroPagDTO {
  idUnidade: number;
  idPaciente: number;
  idMedico: number;
  time: boolean;
  situacao: String;
  statuses: string[];
  statusesHistorico: boolean;
  dataDe: string;
  dataAte: string;
  prescritoViaWaLink: boolean;
}

export class TentativaContatoParmDTO {
  id: number;
  status: string
  dataFimStatus: string;
  justificativa: string;
  ticketZendesk: string;
}

export class DisparoWhatsappParmDTO {
  idPendencia: number;
  phone4Test: string;
}